import { render } from "./Photography.vue?vue&type=template&id=50452979"
import script from "./Photography.vue?vue&type=script&lang=ts"
export * from "./Photography.vue?vue&type=script&lang=ts"
script.render = render

export default script